import paginacaoGenerica from "./paginacaoGenerica";
import paginacaoProjetos from "./paginacaoProjetos";
import paginacaoClienteRural from "./paginacaoClienteRural";
import paginacaoProjetoPorLote from "./paginacaoProjetoPorLote";

export default {
  namespaced: true,
  modules: {
    paginacaoGenerica,
    paginacaoProjetos,
    paginacaoClienteRural,
    paginacaoProjetoPorLote
  }
};
